module.exports = __webpack_public_path__ + "files/ed1a5e5ed1d44d3983ea7978b054f96d.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/ubuntu-bolditalic-webfont.woff
 ** module id = 1028
 ** module chunks = 0
 **/